var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classes},[(_vm.src)?_c('img',{attrs:{"src":_vm.src}}):(_vm.icon || _vm.customIcon)?_c('Icon',{attrs:{"type":_vm.icon,"custom":_vm.customIcon}}):_c('span',{ref:"children",class:[_vm.prefixCls + '-string'],style:(_vm.childrenStyle)},[_vm._t("default")],2)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/avatar/avatar.vue